export const deliverySelect = [
  { title: 'на стороне аптеки', code: 'in_place' },
  { title: 'на стороне операторов "Daribar', code: 'kaspi' },
  { title: 'emdel', code: 'emdel' },
];
